// customStyles.js
const customStyles = (error) => ({
  control: (provided) => ({
    ...provided,
    borderColor: error ? "#da1414" : "#E2E3E5",
    borderWidth: 1,
    borderRadius: 4,
    height: "35px",
    minHeight: "35px",
    boxShadow: "none",
    fontSize: "14px",
    "&:hover": {
      borderColor: error ? "#da1414" : "#777777",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "35px",
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#777777",
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "gray",
    fontSize: "14px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#777777",
    fontSize: "14px",
  }),
  menu: (provided) => ({
    ...provided,
    border: "none",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    fontSize: "14px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#f0f0f0"
      : state.isFocused
      ? "#e9ecef"
      : "white",
    color: "#333",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "&:active": {
      backgroundColor: "#ddd",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e9ecef",
    borderRadius: "4px",
  }),
});

export default customStyles;
